'use es6';

import { PageActionTypes } from './header';
export default {
  [PageActionTypes.ARCHIVE]: PageActionTypes.ARCHIVE,
  [PageActionTypes.ATTACH_TO_LANGUAGE_MASTER]: PageActionTypes.ATTACH_TO_LANGUAGE_MASTER,
  [PageActionTypes.REMOVE_FROM_LANGUAGE_GROUP]: PageActionTypes.REMOVE_FROM_LANGUAGE_GROUP,
  [PageActionTypes.CHANGE_AUDIENCE_ACCESS]: PageActionTypes.CHANGE_AUDIENCE_ACCESS,
  [PageActionTypes.CONVERT]: PageActionTypes.CONVERT,
  [PageActionTypes.CLONE]: PageActionTypes.CLONE,
  [PageActionTypes.DELETE]: PageActionTypes.DELETE,
  [PageActionTypes.SWITCH_LANGUAGE_MASTER]: PageActionTypes.SWITCH_LANGUAGE_MASTER,
  [PageActionTypes.TRANSLATE]: PageActionTypes.TRANSLATE,
  [PageActionTypes.TRANSLATE_BLOG_POST]: PageActionTypes.TRANSLATE_BLOG_POST,
  [PageActionTypes.UNARCHIVE]: PageActionTypes.UNARCHIVE,
  [PageActionTypes.USE_IN_LIST]: PageActionTypes.USE_IN_LIST,
  [PageActionTypes.PUBLISHING_OPTIONS]: 'PUBLISHING_OPTIONS',
  [PageActionTypes.UNPUBLISHING_OPTIONS]: 'UNPUBLISHING_OPTIONS',
  SHOW_CUSTOM_DOMAIN_POST_PUBLISH_MODAL: 'SHOW_CUSTOM_DOMAIN_POST_PUBLISH_MODAL'
};